// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2CecW","gfeWrapper":"CalendarEvent_gfeWrapper__tAlZM"};